// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ element, requiredRole, isLoginRoute }) => {
  const { isAuthenticated, userRole } = useAuth();

  // Helper function to get the appropriate redirect path based on role
  const getRedirectPath = (role) => {
    switch (role) {
      case 'admin':
        return '/admin';
      case 'picker':
      case 'frozen':
        return '/picking';
      case 'storage':
        return '/storage';
      case 'sales':
        return '/sales';
      case 'production':
      case 'production_closer':
        return '/production';
      case 'scanner':
        return '/init';
      case 'checker':
        return '/admin';
      default:
        return '/';
    }
  };

  // If authenticated and it's a login route, redirect to appropriate page
  if (isAuthenticated && isLoginRoute) {
    return <Navigate to={getRedirectPath(userRole)} />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  // Handle role validation
  const isRoleValid = Array.isArray(requiredRole)
    ? requiredRole.includes(userRole)
    : requiredRole === userRole;

  // If role is not valid, redirect to appropriate page
  if (!isRoleValid) {
    return <Navigate to={getRedirectPath(userRole)} />;
  }

  // If authenticated and role matches, render the element
  return element;
};

export default ProtectedRoute;
